import { Typography } from "@mui/material";
import { usePhoneInput } from "react-international-phone";

type Props = {
  value: string;
};

const FormattedPhone = ({ value }: Props) => {
  const { inputValue } = usePhoneInput({
    defaultCountry: "fi",
    value,
  });

  return <Typography>{inputValue}</Typography>;
};

export default FormattedPhone;
